import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';

import { selectTranslations } from 'app/pages/App/slice/selectors';
import { formatNumber } from 'utils/helper';

interface Props {
  inventory: number;
  styles?: CSSProperties;
}

const Inventory = (props: Props) => {
  const { inventory, styles } = props;

  const translations = useSelector(selectTranslations);

  return (
    <span
      style={{
        color: '#29343D',
        width: 'max-content',
        textAlign: 'right',
        ...styles,
      }}
    >
      <span
        style={{
          color: '#808080',
          fontWeight: 400,
          textAlign: 'justify',
        }}
      >
        {'('}
        {formatNumber(inventory || 0)}{' '}
        {translations?.['b2c.txt.in-stock'] ?? ''}
        {')'}
      </span>{' '}
    </span>
  );
};

export default Inventory;
